import { Directive, ViewContainerRef } from "@angular/core"

@Directive({
    selector: "[appAddHost]",
    standalone: false,
})
export class AddDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
